import classNames from 'classnames';
import React from 'react';
const MembersOnlyBadge = (props) => {
    return (React.createElement("div", { className: classNames('members-only-badge', props === null || props === void 0 ? void 0 : props.className) },
        !props.hideIcon && React.createElement("i", { className: props.lightIcon ? 'icon--lock-white' : 'icon--lock', "aria-label": "members only" }),
        React.createElement("span", { className: "label" }, props.title)));
};
export default MembersOnlyBadge;
